import {
    useMemo,
    type FC
} from "react";
import type IDropdownMenuRadioGroupProps from "./type";
import {
    DropdownMenuRadioContext,
    useDropdownMenuContext
} from "../../context";
import {
    useDropdownMenuHeadingInset
} from "../../hook";
import PopoverSurface from "../../../popoverSurface";

const DropdownMenuRadioGroup: FC<IDropdownMenuRadioGroupProps> = ({
    customTheme: customThemeProp,
    children,
    onChange,
    value,
    title
}) => {
    const context = useDropdownMenuContext({
        part: "RadioGroup"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const insetDynamicStyle = useDropdownMenuHeadingInset({
        part: "RadioGroup",
        customTheme
    });

    const radioValue = useMemo(() => ({
        onChange,
        value
    }), [
        onChange,
        value
    ]);

    return <DropdownMenuRadioContext.Provider
        value={radioValue}
    >
        <PopoverSurface.Group
            headingStyle={insetDynamicStyle}
            customTheme={customTheme}
            heading={title}
        >
            {children}
        </PopoverSurface.Group>
    </DropdownMenuRadioContext.Provider>;
};
export default DropdownMenuRadioGroup;
